import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import {
  I2gNgTrackingService,
  ITrackingObject,
  RadioTappedTrackingAction,
} from 'i2g-ng-tracking';

@Component({
  selector: 'i2g-radio-field',
  templateUrl: 'radio-field.component.html',
  styleUrls: ['radio-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioFieldComponent {
  @Input() label: string;
  @Input() group: string;
  @Input() hideLabel: boolean;
  @Input() fieldId: string;
  @Input() value: string;
  @Input() e2eId: string;
  @Input() description: string;
  @Input() fieldControl: AbstractControl;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingTapped: RadioTappedTrackingAction;
  @Input() trackingAdditionalProperties: any;

  @Output() radioClick: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(private _trackingService: I2gNgTrackingService) {}

  onRadioClick(event: Event) {
    if (this.fieldControl && this.trackingObject && this.trackingTapped) {
      this._trackingService.trackEvent(
        this.trackingObject,
        this.trackingTapped.setValue(this.value),
        this.trackingAdditionalProperties
      );
    }

    this.radioClick.emit(event);
  }
}
